/** The authSlice logout action type as a literal: importing `logout` into a store slice creates the
 *  authSlice -> api -> store cycle. `useAuth.test.tsx` pins it to `logout.type`. */
export const AUTH_LOGOUT_ACTION_TYPE = 'auth/logout';
